export interface OptionItem {
  label: string;
  value: string;
  autoText?: string;
  instruction?: string;
}

export interface AdvancedInstructionOptions {
  defaultInstruction: string;
  conciseness: OptionItem[];
  tone: OptionItem[];
  voice: OptionItem[];
  checkboxes: OptionItem[];
}

export const advancedInstructionOptions: AdvancedInstructionOptions = {
  defaultInstruction:
    'Follow the formatting instructions in the examples exactly.',

  conciseness: [
    {
      label: 'Very Concise',
      value: 'very_concise',
      autoText: 'The generated output should be very concise.',
    },
    {
      label: 'Concise',
      value: 'concise',
      autoText: 'The generated output should be concise.',
    },
    {
      label: 'Medium',
      value: 'medium',
      autoText: 'The generated output should be of moderate verbosity.',
    },
    {
      label: 'Verbose',
      value: 'verbose',
      autoText: 'The generated output should be of above average verbosity.',
    },
    {
      label: 'Very Verbose',
      value: 'very_verbose',
      autoText: 'The generated output should very verbose.',
    },
  ],

  tone: [
    {
      label: 'Informal',
      value: 'informal',
      autoText: 'The overall tone of the note should be informal.',
    },
    {
      label: 'Neutral',
      value: 'neutral',
      autoText: 'The overall tone of the note should be neutral.',
    },
    {
      label: 'Professional',
      value: 'professional',
      autoText: 'The overall tone of the note should be professional.',
    },
  ],

  voice: [
    {
      label: 'First Person',
      value: 'first_person',
      autoText:
        'The perspective should be first person, ex.  I have prescribed amlodipine.',
    },
    {
      label: 'Passive Voice',
      value: 'passive_voice',
      autoText:
        'The perspective should be passive, ex. Amlodipine was prescribed.',
    },
    {
      label: 'Third Person',
      value: 'third_person',
      autoText:
        'The perspective should be third person, ex. The doctor prescribed amlodipine.',
    },
  ],

  checkboxes: [
    {
      label: 'Include ICD-10 Codes',
      value: 'include_icd10',
      instruction:
        'Diagnoses in the summary / recommendations section should include the appropriate ICD-10 code in parentheses.',
    },
    {
      label: 'Summarize Diagnoses and Treatments',
      value: 'summarize_diagnoses',
      instruction:
        'At the bottom of the notes, summarize the diagnoses and treatments discussed, with one diagnosis and its treatments per line. Ex: Hypertension: Amlodipine 10 mg daily',
    },
  ],
};
